import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { FormControl, TextField } from '@material-ui/core';
import { post } from '../../Services/http';
import LoadingDots from '../LoadingDots';

const LoginModalChangePasswordForm = ({
  email,
  oldPassword,
  onError,
  onPasswordChanged,
}) => {
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const sendChangePassword = () => {
    if (password !== passwordConfirmation) {
      onError(translate('login.password-mismatch'));
      return;
    }

    setIsLoading(true);
    post('/api/login/changepassword', {
      email,
      oldPassword,
      newPassword: password,
    })
      .then((res) => res.json())
      .then((data) => {
        onError(data.error);

        if (data.success) {
          onPasswordChanged(data);
        } else {
          onError(data.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        err.response.json().then((data) => onError(data.error));
        setIsLoading(false);
      });
  };

  return (
    <>
      <h3>{translate('login.change-password')}</h3>
      <FormControl>
        <label htmlFor="password">{translate('general.password')}</label>
        <TextField
          variant="outlined"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={translate('general.password')}
          type="password"
          disabled={isLoading}
        />
      </FormControl>
      <FormControl>
        <label htmlFor="password-confirmation">
          {translate('login.confirm-password')}
        </label>
        <TextField
          variant="outlined"
          id="password-confirmation"
          value={passwordConfirmation}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
          placeholder={translate('login.confirm-password')}
          type="password"
          disabled={isLoading}
        />
      </FormControl>
      <button
        className="btn btn--primary"
        onClick={sendChangePassword}
        disabled={isLoading}
      >
        {!isLoading && translate('general.send')}
        {isLoading && <LoadingDots size="small" color="white" />}
      </button>
    </>
  );
};

export default LoginModalChangePasswordForm;
